import { render, staticRenderFns } from "./CustomerOpportunitiesAggregatedActivity.vue?vue&type=template&id=87a421ce&scoped=true&"
import script from "./CustomerOpportunitiesAggregatedActivity.vue?vue&type=script&lang=js&"
export * from "./CustomerOpportunitiesAggregatedActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a421ce",
  null
  
)

export default component.exports